import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useDoesUserHavePermission } from "../../../hooks/permissions";
import {
    IApiResponse,
    IPaginatedApiResponse,
} from "../../../utils/types/api-response";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import { UserPermisions } from "../../../utils/types/user";
import {
    fetchClientsForNoteRuleBypass,
    fetchNoteRuleBypasses,
} from "../services/note-rule-bypass.services";
import {
    INoteRuleBypassFilters,
    INoteRuleBypassListRow,
    IProviderClientsForBypass,
    IProviderClientsForBypassFilters,
} from "../types/note-rule-bypass.types";

export function useFetchNoteRuleBypasses(filters: INoteRuleBypassFilters) {
    const canViewNoteRuleBypasses = useDoesUserHavePermission([
        UserPermisions.NOTE_RULE_BYPASS_READ,
    ]);

    return useQuery<
        IPaginatedApiResponse<INoteRuleBypassListRow[]>,
        AxiosError<IPaginatedApiResponse<INoteRuleBypassListRow[]>>
    >({
        queryKey: [
            "note-rule-bypasses",
            handleRemoveEmptyParamFromQueryParams(filters),
        ],
        queryFn: () => fetchNoteRuleBypasses(filters),
        enabled: canViewNoteRuleBypasses,
    });
}

export function useFetchClientsForNoteRuleBypass(
    filters: IProviderClientsForBypassFilters,
    enabled = true
) {
    return useQuery<
        IApiResponse<IProviderClientsForBypass>,
        AxiosError<IApiResponse<IProviderClientsForBypass>>
    >({
        queryKey: [
            "note-rule-bypass-clients",
            handleRemoveEmptyParamFromQueryParams(filters),
        ],
        queryFn: () => fetchClientsForNoteRuleBypass(filters),
        enabled: enabled && Boolean(filters.provider_id),
    });
}
